import sample_1 from './amondo.jpg';

export const amondoImpressions = {
    sample_1,
};
